module.exports = __webpack_public_path__ + "img/exclamation.bb1aa413.svg";